const smartBannerInit = () => {

  document.addEventListener('DOMContentLoaded', () => {

    // const sbClose = document.querySelector('.smartbanner__exit');
    // sbClose.addEventListener('click', () => {
    //   document.querySelector('body').style.paddingTop = '0';
    // })

    const addClassToHTML = () => {
      document.querySelector('html').classList.add('sb');
    }
    const removeClassFromHTML = () => {
      document.querySelector('html').classList.remove('sb');
    }

    document.addEventListener('smartbanner.view', addClassToHTML);
    document.addEventListener('smartbanner.exit', removeClassFromHTML);
  })

}



export { smartBannerInit };
